<div class="ui inverted vertical menu">
    <div class="ui header item">
        <a href="/">
            <img
                src="/assets/images/calendarhero/Full-Color-Dark-Bgrd-2x.png"
                title="CalendarHero"
                style="width: 90%"
            />
        </a>
    </div>

    <div
        *ngFor="let link of navLinks"
        class="ui item"
    >
        <div
            class="header"
            [uiSref]="link.state"
        >
            {{ link.name | uppercase }}
        </div>

        <div
            *ngIf="link.items.length"
            class="menu"
        >
            <div *ngFor="let subLink of link.items">
                <a
                    *ngIf="subLink.state"
                    class="item"
                    [uiSref]="subLink.state"
                    [uiParams]="subLink.params || {}"
                    uiSrefActive="active"
                    uiSrefOpts="{reload: true}"
                >
                    {{ subLink.name }}
                </a>
            </div>
        </div>
    </div>
    <ng-container *ngIf="isAdmin">
        <div
            *ngFor="let link of adminLinks"
            class="ui item"
        >
            <div
                class="header"
                [uiSref]="link.state"
            >
                {{ orgName || 'admin' | uppercase }}
            </div>

            <div
                *ngIf="link.items.length"
                class="menu"
            >
                <div *ngFor="let subLink of link.items">
                    <a
                        *ngIf="subLink.state"
                        class="item"
                        [uiSref]="subLink.state"
                        uiSrefActive="active"
                        uiSrefOpts="{reload: true}"
                    >
                        {{ subLink.name }}
                    </a>
                </div>
            </div>
        </div>
    </ng-container>
</div>
